require('select2');
import { Breakpoints } from 'JBSrc/constants';
import { sessionFlash } from 'JBSrc/session-flash';
let moment = require('moment');

export function debounce(callback, wait) {
	let timerId;
	return (...args) => {
		clearTimeout(timerId);
		timerId = setTimeout(() => {
			callback(...args);
		}, wait);
	};
};

export function fieldLogic(){
	let preview, input, fieldname, index, files, value, current_value, remove;

	// Multiple select to suggestion inputs
	$('.suggest-multiple').select2({theme: 'bootstrap4'});

	// BOOTSTRAP popovers
	$('[data-toggle="popover"]').popover({
		container: 'body',
		trigger: is_touch_device() ? 'click' : 'hover',
		placement: 'top',
		html: true,
	});
	if(window.fieldsLogicIntialized !== true) {
		$(document).on('click', '[data-toggle="popover"]', function(e){
			e.preventDefault();
			$('[data-toggle="popover"]').not(this).popover('hide'); //all but this
		});
	}

	$('.table-responsive').on('show.bs.dropdown', function () {
 		$('.table-responsive').css( "overflow", "inherit" );
	});

	$('.table-responsive').on('hide.bs.dropdown', function () {
 		$('.table-responsive').css( "overflow", "auto" );
	});

	// Date pickers
	$('.date-field:not(:has(.flatpickr-input))').flatpickr({
		enableTime: false,
		dateFormat: "Y-m-d",
		altInput: true,
		altFormat: "d M Y",
		static: true,
		onReady: function(selectedDates, dateStr, instance) {
	        dates_on_ready(selectedDates, dateStr, instance);
	    },
		onChange: function(selectedDates, dateStr, instance) {
	        dates_on_change(selectedDates, dateStr, instance);
	    }
	});
	$('.time-field:not(:has(.flatpickr-input))').flatpickr({
		enableTime: true,
		dateFormat: "Y-m-d H:i",
		altInput: true,
		altFormat: "d M Y H:i",
		static: true,
		defaultHour: 0,
		time_24hr: true,
		shorthandCurrentMonth: true,
		minuteIncrement: 15,
		onReady: function(selectedDates, dateStr, instance) {
	        dates_on_ready(selectedDates, dateStr, instance);
	    },
		onChange: function(selectedDates, dateStr, instance) {
	        dates_on_change(selectedDates, dateStr, instance);
	    }
	});

	// Asset fields
	if(window.fieldsLogicIntialized !== true){
		$('.form-group.assets').each(function(){
			fieldname = $(this).data('field');
		});
		$(document).on('change', '.form-group.assets input', function(){
			fieldname = $(this).closest('.form-group').data('field');
			assets_updateImageDisplay(fieldname);
		});
		$(document).on('click', '[data-action="assets-delete"][data-field]', function(e){
			e.preventDefault();
			const dt = new DataTransfer();
			const index = $(this).data('index');
			const fieldname = $(this).data('field');
			const preview = $('[data-field="' + fieldname + '"] .selected-list');
			const input = document.querySelector('[data-field="' + fieldname + '"] input[type=file]');
			const { files } = input;

			// Loop through files on the input
			for (let i = 0; i < files.length; i++) {
				const file = files[i];

				// Add the files to the data transfer list to keep
				if (index !== i) {
					dt.items.add(file);
				
				// Remove the preview file row
				} else {
					preview.find('[data-index="' + index + '"]').remove();
				}
			}

			// Assign the updated list
			input.files = dt.files; 

			// Remove the preview list if there are no files left
			if (input.files.length === 0) {
				preview.html('');
			}

			// Cleanup the list of left over files
			$('[data-field="' + fieldname + '"] input[type=file]').trigger('change');
		});

		$(document).on('click', '.assetExistRemove', function(e){
			remove = $(this).data('remove');
			value = $(this).data('value');
			index = $(this).data('key');
			current_value = $('input[name="' + remove + '"]').val();
			current_value = current_value != '' && current_value.indexOf(',') !== -1 ? current_value.split(',') : [];
			if(!_.isArray(current_value)){
				current_value = [];
			}
			current_value.push(value);
			current_value = _.uniq(current_value);
			$('input[name="' + remove + '"]').val(current_value.join(','));

			//remove original
			if($(this).closest('.form-group').find('.current-file [data-key="' + index + '"]').length){
				$(this).closest('.form-group').find('.current-file [data-key="' + index + '"]').remove();
			}
		});
	}

	window.fieldsLogicIntialized = true;
}

export function dates_on_ready(selectedDates, dateStr, instance){
	let end_field_id = '', end_field = '', hasEndField = false, interval;
	switch ($(instance.input).attr('id')) {
		case 'event_start_time':
			end_field_id = '#event_end_time';
		break;

		case 'event_setup_start_time':
			end_field_id = '#event_setup_end_time';
		break;

		case 'event_dates_event_start_time':
			end_field_id = '#event_dates_event_end_time';
		break;

		case 'event-date_from':
			end_field_id = '#event-date_to';
		break;
	}

	if(end_field_id != ''){
		interval = setInterval(function(){
			end_field = document.querySelector(end_field_id)._flatpickr;
			hasEndField = end_field !== undefined;

			if(hasEndField){
				end_field.set('minDate', selectedDates[0]);
				if(end_field.selectedDates.length === 0){
					end_field.setDate(selectedDates);
				}
				clearInterval(interval);
			}
		}, 500);
	}
}

export function dates_on_change(selectedDates, dateStr, instance){
	let end_field = '', setup_start_field = '', setup_end_field = '', dateObj, compareDate;
	switch ($(instance.input).attr('id')) {
		case 'event_start_time':
			end_field = document.querySelector("#event_end_time")._flatpickr;
			setup_start_field = document.querySelector('#event_setup_start_time')._flatpickr;
			setup_end_field = document.querySelector('#event_setup_end_time')._flatpickr;

			dateObj = moment(selectedDates[0]);
			setup_start_field.set('maxDate', dateObj.toDate());
			dateObj.subtract(1, 'h');
			setup_start_field.setDate(dateObj.toDate());
		break;

		case 'event_end_time':
			setup_end_field = document.querySelector('#event_setup_end_time')._flatpickr;
			dateObj = moment(selectedDates[0]);
		break;

		case 'event_setup_start_time':
			end_field = document.querySelector("#event_setup_end_time")._flatpickr;
		break;

		case 'event_dates_event_start_time':
			end_field = document.querySelector("#event_dates_event_end_time")._flatpickr;
		break;

		case 'event-date_from':
			end_field = document.querySelector("#event-date_to")._flatpickr;
		break;
	}

	if(end_field != ''){
		end_field.set('minDate', selectedDates[0]);
		dateObj = moment(selectedDates[0]);
		if(end_field.selectedDates.length > 0){
			compareDate = moment(end_field.selectedDates[0]);

			if(compareDate.isSameOrBefore(dateObj)){
				dateObj.add(3, 'h');
				end_field.setDate(dateObj.toDate());
			}
		}else{
			dateObj.add(3, 'h');
			end_field.setDate(dateObj.toDate());
		}
	}

	if(setup_end_field != ''){
		if(setup_end_field.selectedDates.length > 0){
			compareDate = moment(setup_end_field.selectedDates[0]);

			if(compareDate.isSameOrBefore(dateObj)){
				setup_end_field.set('minDate', dateObj.toDate());
				dateObj.add(1, 'h');
				setup_end_field.setDate(dateObj.toDate());
			}
		}else{
			setup_end_field.set('minDate', dateObj.toDate());
			dateObj.add(1, 'h');
			setup_end_field.setDate(dateObj.toDate());
		}
	}
}

export function assets_validFileType(fieldname, file){
	if(window.fileTypes[fieldname].length === 0){
		return true;
	}
	return $.inArray(file.type, window.fileTypes[fieldname]) !== -1 || file.type === "";
};

export function assets_returnFileSize(number) {
	if(number < 1024) {
		return number + 'bytes';
	} else if(number >= 1024 && number < 1048576) {
		return (number/1024).toFixed(1) + 'KB';
	} else if(number >= 1048576) {
		return (number/1048576).toFixed(1) + 'MB';
	}
};

export function assets_updateImageDisplay(fieldname){
	let preview, input, html, files, maxFiles;

	input = document.querySelector('[data-field="' + fieldname + '"] input[type=file]');
	html = [];
	preview = $('[data-field="' + fieldname + '"] .selected-list');
	maxFiles = 'maxFiles' in input.dataset ? parseInt(input.dataset.maxFiles) : 1;
	files = input.files;

	if(files.length > maxFiles){
		sessionFlash(`A maximum of ${maxFiles} files can be selected for this input. Please try again.`, false);
	}

	if(files.length > 0 && files.length <= maxFiles) {
		html.push('<ul class="list-group list-group-flush list-group--action-list">');

		for(let i = 0; i < files.length; i++) {
			if(assets_validFileType(fieldname, files[i])) {
				html.push('<li class="list-group-item" data-index="' + i + '">' + files[i].name + ' (' + assets_returnFileSize(files[i].size) + ') <a href="#assets-delete" class="btn btn-xs btn-danger" data-field="' + fieldname + '" data-index="' + i + '" data-action="assets-delete">Remove</a></li>');
			} else {
				html.push('<li class="list-group-item text-danger">' + files[i].name + ' <small>Not a valid file type. Update your selection.</small></li>');
			}
		}
		html.push('</ul>');
	}
	preview.html(html.join("\n"));
};

export function is_touch_device() {
	let prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	let mq = function(query) {
		return window.matchMedia(query).matches;
	}

	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		return true;
	}

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	let query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}

export function executiveTableAdjust(){
	if($('.myEvents-row').length){
		if($(window).width() < Breakpoints.sm){
			$('.table-responsive').addClass('fixed-left-col');
			$('.myEvents-row').each(function(){
				let height = $(this).find('td:first').css('height');
				$(this).find('td').css('height', (parseFloat(height)+1) + 'px');
				$(this).addClass('mobile-row');
			});
			$('.table--executive thead tr').each(function(){
				let height = $(this).find('th:first').css('height');
				$(this).find('th').css('height', (parseFloat(height)+1) + 'px');
				$(this).addClass('mobile-row');
			});
		}else{
			$('.table-responsive').removeClass('fixed-left-col');
			$('.myEvents-row, .table--executive thead tr').removeClass('mobile-row');
			$('.myEvents-row td, .table--executive thead tr th').css('height', 'auto');
		}
	}
}
